<script setup>
defineProps({
    data: {
        type: Object,
        default: () => ({}),
    },
})

const emit = defineEmits(['close'])

function close() {
    emit('close')
}
</script>

<template>
    <div>
        <h2>Error</h2>
        <p>{{ data.message || 'Something went wrong' }}</p>
        <button @click="close">OK</button>
    </div>
</template>
